module.exports = __webpack_public_path__ + "static/media/googlePin10.e68a02d3.svg";